export function promoObserver() {
	const $container = document.querySelector('.js-promo-video');
	const promoVideo = app.classInstance.get($container);

	if (!promoVideo) return;

	const observer = new IntersectionObserver((callback) => {
		callback.forEach((entry) => {
			if (entry.isIntersecting) {
				promoVideo.video.play();
			} else {
				promoVideo.video.pause();
			}
		});
	});
	observer.observe($container);
}
